module.exports = __webpack_public_path__ + "officialStatic/img/detail-five-bg.4a81d75.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/solution/detail-five-bg.png
// module id = E2d/
// module chunks = 0